import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import ProfileContainer from '../../containers/profiles/ProfileContainer';
import SiderNav from './SiderNav';
import ProjectOverviewContainer from '../../containers/projects/ProjectOverviewContainer';
import MyEnterpriseListContainer from '../../containers/enterprises/MyEnterpriseListContainer';
import PrimeContractDetailContainer from '../../containers/prime-contracts/PrimeContractDetailContainer';
import PrimeContractEditContainer from '../../containers/prime-contracts/PrimeContractEditContainer';
import PrimeContractCreateContainer from '../../containers/prime-contracts/PrimeContractCreateContainer';
import ProjectConfigEditContainer from '../../containers/projects/ProjectConfigEditContainer';
import ProfileEditContainer from '../../containers/profiles/ProfileEditContainer';
import LoginContainer from '../../containers/auth/LoginContainer';
import PermissionDeniedContainer from '../../containers/common/PermissionDeniedContainer';
import MyEnterpriseDetailContainer from '../../containers/enterprises/MyEnterpriseDetailContainer';
import MyEnterpriseEditContainer from '../../containers/enterprises/MyEnterpriseEditContainer';
import PageHeader from './PageHeader';
import BidChanceListContainer from '../../containers/bid-chances/BidChanceListContainer';
import Breadcrumbs from './Breadcrumbs';
import BidPackageDetailContainer from '../../containers/bid-packages/BidPackageDetailContainer';
import BidPackageCreateContainer from '../../containers/bid-packages/BidPackageCreateContainer';
import BidPackageUpdateContainer from '../../containers/bid-packages/BidPackageUpdateContainer';
import BidderDetailContainer from '../../containers/bidders/BidderDetailContainer';
import BidProposalCreateContainer from '../../containers/bid-chances/BidProposalCreateContainer';
import BidProposalDetailContainer from '../../containers/bid-chances/BidProposalDetailContainer';
import ProjectSharedFileListContainer from '../../containers/projects/ProjectSharedFileListContainer';
import EnterpriseSelectContainer from '../../containers/auth/EnterpriseSelectContainer';
import EnterpriseCreateContainer from '../../containers/auth/EnterpriseCreateContainer';
import PartnerInvitationListContainer from '../../containers/partners/PartnerInvitationListContainer';
import PartnerManagementContainer from '../../containers/partners/PartnerManagementContainer';
import PartnerRegistrationContainer from '../../containers/partners/PartnerRegistrationContainer';
import PrivateRoute from '../auth/PrivateRoute';
import { Layout } from 'antd';
import ForgotPasswordContainer from '../../containers/auth/ForgotPasswordContainer';
import ForgotPasswordVerificationContainer from '../../containers/auth/ForgotPasswordVerificationContainer';
import EmailVerificationResultContainer from '../../containers/auth/EmailVerificationResultContainer';
import ResetPasswordContainer from '../../containers/auth/ResetPasswordContainer';
import EmailVerificationRequestContainer from '../../containers/auth/EmailVerificationRequestContainer';
import BidPackageBidListContainer from '../../containers/bid-packages/BidPackageBidListContainer';
import BidPackageBudgetListContainer from '../../containers/bid-packages/BidPackageBudgetListContainer';
import { RootState } from '../../modules';
import SignupContainer3 from '../../containers/auth/SignupContainer3';
import DeleteUserAccountContainer from '../../containers/auth/DeleteUserAccountContainer';
import UpdateUserPhoneContainer from '../../containers/auth/UpdateUserPhoneContainer';
import VendorListContainer from '../../containers/vendors/VendorListContainer';
import MainContainer from '../../containers/MainContainer';
import VendorApplyResultContainer from '../../containers/auth/VendorApplyResultContainer';
import BidChance2DetailContainer from '../../containers/bid-chances/BidChance2DetailContainer';
import BidProposalSubmitResultContainer from '../../containers/bid-chances/BidProposalSubmitResultContainer';
import ExpenseListContainer from '../../containers/expenses/ExpenseListContainer';
import Expense3ListContainer from '../../containers/expenses/Expense3ListContainer';
import InvoiceListPLContainer from '../../containers/invoices/InvoiceListPLContainer';
import ReportListPLContainer from '../../containers/reports/ReportListPLContainer';
import PCCOListContainer from '../../containers/prime-contracts/PCCOListContainer';
import CollaboratorListContainer from '../../containers/partners/CollaboratorListContainer';
import ScheduleListContainer from '../../containers/schedules/ScheduleListContainer';
import ScheduleChartContainer from '../../containers/schedules/ScheduleChartContainer';
import WorkRecordListContainer from '../../containers/work-records/WorkRecordListContainer';
import WorkRecordStatContainer from '../../containers/work-records/WorkRecordStatContainer';
import RegisterFAContainer from '../../containers/financial-asset/RegisterFAContainer';
import JoinMemberContainer from '../../containers/auth/JoinMemberContainer';
import TaskListContainer from '../../containers/tasks/TaskListContainer';
import BidInvitationContainer from '../../containers/common/BidInvitationContainer';
import RevenueContainer from '../../containers/revenues/RevenueContainer';
import DirectWorkerListContainer from '../../containers/work-records/DirectWorkerListContainer';

function Routers() {
  const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);
  const enterpriseRoutes = [
    {
      path: '/enterprises/:enterpriseId/expenses',
      name: '비용관리',
      Component: ExpenseListContainer,
    },
    {
      path: '/enterprises/:enterpriseId/revenues',
      name: '매출관리',
      Component: RevenueContainer,
    },
    {
      path: '/enterprises/:enterpriseId/myEnterprise',
      name: '내회사',
      Component: MyEnterpriseDetailContainer,
    },
    {
      path: '/enterprises/:enterpriseId/myEnterprise/edit',
      name: '내회사 정보 수정',
      Component: MyEnterpriseEditContainer,
    },
    {
      path: '/enterprises/:enterpriseId/main',
      name: '공사 리스트',
      Component: MainContainer,
    },
    {
      path: '/enterprises/:enterpriseId/vendors',
      name: '거래처 관리',
      Component: VendorListContainer,
    },
    {
      path: '/enterprises/:enterpriseId/partnerManagement',
      name: '협력업체 관리',
      Component: PartnerManagementContainer,
    },
    {
      path: '/enterprises/:enterpriseId/partnerInvitations',
      name: '협력업체 등록요청 관리',
      Component: PartnerInvitationListContainer,
    },
    {
      path: '/enterprises/:enterpriseId/bidChances',
      name: '수주 관리',
      Component: BidChanceListContainer,
    },
    // {
    //   path: '/enterprises/:enterpriseId/bidChances/:bidChanceId',
    //   name: '수주기회 상세',
    //   Component: BidChanceDetailContainer,
    // },
    {
      path: '/enterprises/:enterpriseId/bidChances/:bidChanceId/bidProposals/create',
      name: '견적가 제출',
      Component: BidProposalCreateContainer,
    },
    {
      path: '/enterprises/:enterpriseId/bidChances/:bidChanceId/bidProposals/:bidProposalId/detail',
      name: '견적가 상세',
      Component: BidProposalDetailContainer,
    },
    {
      path: '/enterprises/:enterpriseId/profile',
      name: '내 계정',
      Component: ProfileContainer,
    },
    {
      path: '/enterprises/:enterpriseId/profile/edit',
      name: '내 계정 수정',
      Component: ProfileEditContainer,
    },
    {
      path: '/enterprises/:enterpriseId/profile/reset-password',
      name: '비밀번호 재설정',
      Component: ResetPasswordContainer,
    },
    {
      path: '/enterprises/:enterpriseId/profile/delete',
      name: '계정 삭제',
      Component: DeleteUserAccountContainer,
    },
    {
      path: '/enterprises/:enterpriseId/profile/update-user-phone',
      name: '사용자 휴대전화번호 변경',
      Component: UpdateUserPhoneContainer,
    },
    // {
    //   path: '/enterprises/:enterpriseId/profile/sig-pad',
    //   name: '프로필 서명',
    //   Component: ProfileSignaturePadContainer,
    // },
    // {
    //   path: '/enterprises/:enterpriseId/create-project',
    //   name: '공사 생성',
    //   Component: ProjectCreateContainer,
    // },
  ];

  const projectRoutes = [
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/dashboard',
      name: '공사 대시보드',
      Component: ProjectOverviewContainer,
    },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/edit',
    //   name: '공사 수정',
    //   Component: ProjectDetailEditContainer,
    // },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/settings',
      name: '공사 설정 수정',
      Component: ProjectConfigEditContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/primeContracts',
      name: '도급 계약',
      Component: PrimeContractDetailContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/primeContracts/create',
      name: '도급 계약 추가',
      Component: PrimeContractCreateContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/primeContracts/:contractId/edit',
      name: '도급 계약 수정',
      Component: PrimeContractEditContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/changeOrders/list',
      name: '설계변경',
      Component: PCCOListContainer,
    },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/subContracts',
    //   name: '하도급 계약 리스트',
    //   Component: SubContractListContainer,
    // },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/subContracts/create',
    //   name: '하도급 계약 추가',
    //   Component: SubContractCreateContainer,
    // },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/subContracts/:contractId',
    //   name: '하도급 계약 상세',
    //   Component: SubContractDetailContainer,
    // },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/subContracts/:contractId/edit',
    //   name: '하도급 계약 수정',
    //   Component: SubContractEditContainer,
    // },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/subContracts/:contractId/scca-table-edit',
    //   name: '하도급 계약 요율 수정',
    //   Component: SCCATableEditContainer,
    // },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/subContracts/:contractId/sov/edit',
    //   name: '하도급 계약 내역서 수정',
    //   Component: ContractSOVEditContainer,
    // },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/subContracts/:contractId/changeOrders/create',
    //   name: '하도급 설계변경 추가',
    //   Component: SCCOCreateContainer,
    // },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/subContracts/:contractId/changeOrders/:changeOrderId',
    //   name: '하도급 설계변경 상세',
    //   Component: SCCODetailContainer,
    // },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/subContracts/:contractId/changeOrders/:changeOrderId/sov-edit',
    //   name: '하도급 설계변경 내역서 수정',
    //   Component: SCCOSOVEditContainer,
    // },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/subContracts/:contractId/changeOrders/:changeOrderId/edit',
    //   name: '하도급 설계변경 수정',
    //   Component: SCCOUpdateContainer,
    // },

    {
      path: '/enterprises/:enterpriseId/projects/:projectId/bidPackagesBidding',
      name: '거래처 입찰 관리',
      Component: BidPackageBidListContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/bidPackagesBudgeting',
      name: '견적요청 리스트',
      Component: BidPackageBudgetListContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/bidPackagesBidding/create',
      name: '입찰 생성',
      Component: BidPackageCreateContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/bidPackagesBudgeting/create',
      name: '견적 생성',
      Component: BidPackageCreateContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/bidPackagesBidding/:bidPackageId',
      name: '입찰 상세',
      Component: BidPackageDetailContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/bidPackagesBudgeting/:bidPackageId',
      name: '견적요청 상세',
      Component: BidPackageDetailContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/bidPackagesBidding/:bidPackageId/edit',
      name: '입찰 수정',
      Component: BidPackageUpdateContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/bidPackagesBudgeting/:bidPackageId/edit',
      name: '견적 수정',
      Component: BidPackageUpdateContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/bidPackagesBidding/:bidPackageId/bidders/:bidderId',
      name: '업체 상세',
      Component: BidderDetailContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/bidPackagesBudgeting/:bidPackageId/bidders/:bidderId',
      name: '업체 상세',
      Component: BidderDetailContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/bidPackages/:bidPackageId/bidders/:bidderId/bidProposals/:bidProposalId/detail',
      name: '견적가 상세',
      Component: BidProposalDetailContainer,
    },
    // {
    //   path: '/enterprises/:enterpriseId/projects/:projectId/partnerManagement',
    //   name: '공사참여자',
    //   Component: PartnerManagementContainer,
    // },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/collaborators',
      name: '공사참여자',
      Component: CollaboratorListContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/shared-files',
      name: '공유 파일',
      Component: ProjectSharedFileListContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/expenses',
      name: '지출 리스트',
      Component: Expense3ListContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/invoices',
      name: '청구서 리스트',
      Component: InvoiceListPLContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/report',
      name: '보고서',
      Component: ReportListPLContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/schedules/list',
      name: '공정계획(리스트)',
      Component: ScheduleListContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/schedules/chart',
      name: '공정계획(공정차트)',
      Component: ScheduleChartContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/workRecords/list',
      name: '작업일보',
      Component: WorkRecordListContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/workRecords/statistics',
      name: '일투입현황',
      Component: WorkRecordStatContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/workRecords/direct-worker-list',
      name: '출역현황',
      Component: DirectWorkerListContainer,
    },
    {
      path: '/enterprises/:enterpriseId/projects/:projectId/tasks',
      name: '업무',
      Component: TaskListContainer,
    },
  ];

  const generateBreadcrumb = (routes: any) => {
    return routes.map(({ path, name, Component, location }: any, key: any) => (
      <Route
        exact
        path={path}
        key={key}
        location={location}
        render={(props: any) => {
          const crumbs = routes
            // Get all routes that contain the current one.
            .filter(({ path }: any) => props.match.path.includes(path))
            // Swap out any dynamic routes with their param values.
            // E.g. "/pizza/:pizzaId" will become "/pizza/1"
            .map(({ path, ...rest }: any) => ({
              path: Object.keys(props.match.params).length
                ? Object.keys(props.match.params).reduce(
                    (path, param) =>
                      path.replace(`:${param}`, props.match.params[param]),
                    path,
                  )
                : path,
              ...rest,
            }));

          return isLoggedIn ? (
            <>
              <Breadcrumbs crumbs={crumbs} />
              <Component {...props} />
            </>
          ) : (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location.pathname },
              }}
            />
          );

          // return (
          //   <>
          //     <Breadcrumbs crumbs={crumbs} />
          //     <Component {...props} />
          //   </>
          // );
        }}
      />
    ));
  };

  return (
    <Switch>
      <Route path="/enterprises/:enterpriseId/projects/:projectId">
        {/* {Mobile() && (
          <Alert
            message={`안녕하세요.`}
            type={'info'}
            closable
            style={{ marginTop: '5px', marginBottom: '5px' }}
          />
        )} */}
        <Layout style={{ minHeight: '100vh' }}>
          <SiderNav>
            <Switch>{generateBreadcrumb(projectRoutes)}</Switch>
          </SiderNav>
        </Layout>
      </Route>
      <Route path="/enterprises/:enterpriseId">
        {/* {Mobile() && (
          <Alert
            message={`안녕하세요.`}
            type={'info'}
            closable
            style={{ marginTop: '5px', marginBottom: '5px' }}
          />
        )} */}
        <PageHeader>
          <Switch>{generateBreadcrumb(enterpriseRoutes)}</Switch>
          {/* <Switch>
            <PrivateRoute
              path="/enterprises/:enterpriseId/myEnterprise/detail"
              Component={MyEnterpriseDetailContainer}
              exact
            />
            <PrivateRoute
              path="/enterprises/:enterpriseId/myEnterprise/edit"
              Component={MyEnterpriseEditContainer}
              exact
            />
            <PrivateRoute
              path="/enterprises/:enterpriseId/main"
              Component={MainContainer}
            />
            <PrivateRoute
              path="/enterprises/:enterpriseId/partners/:partnerId"
              Component={PartnerDetailContainer}
            />
            <PrivateRoute
              path="/enterprises/:enterpriseId/partners"
              Component={PartnerListContainer}
            />
            <PrivateRoute
              path="/enterprises/:enterpriseId/bidChances/:bidChanceId"
              Component={BidChanceDetailContainer}
            />
            <PrivateRoute
              path="/enterprises/:enterpriseId/bidChances"
              Component={BidChanceListContainer}
            />
            <PrivateRoute
              path="/enterprises/:enterpriseId/profile/edit"
              Component={ProfileEditContainer}
            />
            <PrivateRoute
              path="/enterprises/:enterpriseId/profile"
              Component={ProfileContainer}
            />
            <PrivateRoute
              path="/enterprises/:enterpriseId/profile/sig-pad"
              Component={ProfileSignaturePadContainer}
            />
            <PrivateRoute
              path="/enterprises/:enterpriseId/projects/create"
              Component={ProjectCreateContainer}
            />
          </Switch> */}
        </PageHeader>
      </Route>
      <Route path="/enterprises" component={MyEnterpriseListContainer} exact />
      <Route path="/login" component={LoginContainer} />
      <Route path="/register" component={SignupContainer3} />
      <Route path="/join/:token" component={JoinMemberContainer} />
      <Route
        path="/auth/forgot-password-verification/:newPasswordToken"
        component={ForgotPasswordVerificationContainer}
      />
      <Route path="/auth/forgot-password" component={ForgotPasswordContainer} />
      <Route path="/register-fa" component={RegisterFAContainer} />
      <Route
        path="/bid-chances/:bidChanceId"
        component={BidChance2DetailContainer}
        exact
      />
      <Route
        path="/bid-chances/:bidChanceId/bidProposals/create"
        component={BidProposalCreateContainer}
        exact
      />
      <Route
        path="/apply-vendor-result"
        component={VendorApplyResultContainer}
        exact
      />
      <Route
        path="/bid-proposal-submit-result"
        component={BidProposalSubmitResultContainer}
        exact
      />
      <Route path="/bid-invitation" component={BidInvitationContainer} exact />
      <Route
        path="/select-enterprise"
        component={EnterpriseSelectContainer}
        exact
      />
      <Route
        path="/create-enterprise"
        component={EnterpriseCreateContainer}
        exact
      />
      <Route
        path="/email-verification-request"
        component={EmailVerificationRequestContainer}
        exact
      />
      <Route
        path="/email-verification-result"
        component={EmailVerificationResultContainer}
        exact
      />
      <PrivateRoute
        path="/partner-registration/:enterpriseId"
        Component={PartnerRegistrationContainer}
        exact
      />
      <Route path="/no-permission" component={PermissionDeniedContainer} />
      <Route
        // path 를 따로 정의하지 않으면 모든 상황에 렌더링됨
        render={({ location }: any) => (
          <div>
            <h2>이 페이지는 존재하지 않습니다:</h2>
            <p>{location.pathname}</p>
            {/* <button onClick={() => loginWithRedirect()}>Log In</button> */}
          </div>
        )}
      />
    </Switch>
  );
}

export default Routers;
